import { jwtDecode } from "jwt-decode";
import dayjs from 'dayjs';
import axios from 'axios';
import { updateAccessToken } from '../actions/userActions';
import { BASE_URL } from '../constants/urlConstants'

const baseURL = ''
const axiosInstance = (userInfo, dispatch) => {

    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo?.access}`
        }
    })

    instance.interceptors.request.use(async req => {
        
        
        const user = jwtDecode(userInfo.access)
        
        const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 5000;
        if (!isExpired) return req

        const response = await axios.post(
            `${BASE_URL}/users/token/refresh/`,
            { refresh: userInfo.refresh },
        )

        dispatch(updateAccessToken(response.data))
        req.headers.Authorization = `Bearer ${response.data.access}`
        return req

    })

    return instance

}
export default axiosInstance;